export default "__VITE_ASSET__DOORVWCZ__"